"use strict";
var FBQ = (function (window) {
    var grant = function () {
        if (!window.fbq || process.env.MIX_APP_ENV !== 'production') {
            return;
        }
        try {
            window.fbq('consent', 'grant');
        }
        catch (e) {
            if (e instanceof Error) {
                Bugsnag.notify(e);
            }
            else {
                Bugsnag.notify('fbq.ts caught non instance of Error.', function (event) {
                    event.addMetadata('error', {
                        error: e
                    });
                });
            }
        }
    };
    var revoke = function () {
        if (!window.fbq || process.env.MIX_APP_ENV !== 'production') {
            return;
        }
        try {
            window.fbq('consent', 'revoke');
        }
        catch (e) {
            if (e instanceof Error) {
                Bugsnag.notify(e);
            }
            else {
                Bugsnag.notify('fbq.ts caught non instance of Error.', function (event) {
                    event.addMetadata('error', {
                        error: e
                    });
                });
            }
        }
    };
    return {
        grant: grant,
        revoke: revoke
    };
})(window);
module.exports = FBQ;
